import HourglassIcon from '@jetbrains/icons/hourglass.svg'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import classNames from 'classnames'

import {useDistanceToNow} from '../../../../../../hooks/useTimeSelector'
import Popup from '../../../../../common/Popup/Popup.lazy'
import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'
import {getStatus} from '../EnableAgentForm.utils'

import styles from './EnableTimer.css'

type Props = {
  iconClassName?: string
  enabled?: boolean
  statusSwitchTime: string
}
const POPUP_DIRECTIONS = [Directions.TOP_LEFT, Directions.BOTTOM_LEFT]

function EnableTimer({iconClassName, enabled, statusSwitchTime}: Props) {
  const statusSwitchFromNow = useDistanceToNow(statusSwitchTime)
  const timerMessage = `Will be automatically ${getStatus(!enabled)} ${statusSwitchFromNow}.`
  const anchor = <SvgIcon icon={HourglassIcon} className={classNames(iconClassName, styles.icon)} />
  return (
    <Dropdown anchor={anchor} clickMode={false} hoverMode hoverHideTimeOut={300}>
      <Popup directions={POPUP_DIRECTIONS} className={styles.popup}>
        {timerMessage}
      </Popup>
    </Dropdown>
  )
}

export default EnableTimer
